import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  className?: string;
  color?: string;
}
export const Logo: React.FC<LogoProps> = ({
  className = '',
  color
}) => {
  return <Link to="/" className={`inline-flex items-center ${className}`} data-id="element-564">
      <span className="text-xl md:text-2xl font-bold" data-id="element-565">
        <span className="text-primary" data-id="element-566">ZERO</span>
        <span className="text-gray-400 mx-1" data-id="element-567">|</span>
        <span className="text-primary" data-id="element-568">TO</span>
        <span className="text-gray-400 mx-1" data-id="element-569">|</span>
        <span className="text-primary" data-id="element-570">TEN</span>
      </span>
    </Link>;
};